(function () {
  if (window.__P2P_STYLIZE_EDIT_BOUND__) return;
  window.__P2P_STYLIZE_EDIT_BOUND__ = true;

  function init() {
    const root = document.querySelector('.p2p-stylize');
    if (!root) return;

    function getSearchParams() {
      try {
        return new URLSearchParams(window.location.search || '');
      } catch (_) {
        return new URLSearchParams();
      }
    }

    function hasDataEntryFlag() {
      return getSearchParams().get('data') === 'true';
    }

    function redirectToStep1() {
      const url = root.dataset.step1RedirectUrl || 'https://prompt2prints.com/pages/photo-to-canvas';
      window.location.replace(url);
    }

    function buildNextUrl(baseStr) {
      if (!baseStr) return baseStr;

      try {
        const nextUrl = new URL(baseStr, window.location.origin);
        const currentParams = getSearchParams();
    currentParams.set('data', 'true');
        currentParams.forEach((value, key) => {
          nextUrl.searchParams.set(key, value);
        });

        return nextUrl.toString();
      } catch (_) {
        return baseStr;
      }
    }

    if (!hasDataEntryFlag()) {
      redirectToStep1();
      return;
    }

    const continueUrl = root.dataset.continueUrl || 'https://prompt2prints.com/products/canvas?syncMode=pdp-img&data=true';
    const uploadedKey = root.dataset.uploadedImageKey || 'pdpUploadedImage';
    const originalKey = root.dataset.originalImageKey || 'pdpOriginalImage';
    const stylizedKey = root.dataset.stylizedImageKey || 'pdpStylizedImage';
    const editedKey = root.dataset.editedImageKey || 'pdpEditedImage';
    const printImageKey = root.dataset.printImageKey || 'pdp-select-img';

    const imgOriginal = root.querySelector('#imgOriginal');
    const imgStyled = root.querySelector('#imgStyled');
    const styledWrap = root.querySelector('#styledWrap');
    const splitHandle = root.querySelector('#splitHandle');
    const splitWrap = root.querySelector('#splitWrap');
    const zoomStage = root.querySelector('#zoomStage');
    const zoomResetBtn = root.querySelector('#zoomResetBtn');
    const labelBefore = root.querySelector('#labelBefore');
    const labelAfter = root.querySelector('#labelAfter');
    const previewHint = root.querySelector('.p2p-stylize__preview-hint');
    const applyEditBtn = root.querySelector('#applyEditBtn');
    const continueBtn = root.querySelector('#edit-continueBtn');
    const reEditBtn = root.querySelector('#reEditBtn');
    const descTextarea = root.querySelector('#step3Description');
    const dimensionGrid = root.querySelector('#step3DimensionGrid');
    const orientationTabs = root.querySelectorAll('.p2p-step3-orientation-tab');
    const tweaksPanel = root.querySelector('.p2p-stylize__tweaks');
    const tweaksClose = root.querySelector('.p2p-stylize__tweaks-close');
    const ctaActions = root.querySelector('#ctaActions');
    const ctaStatus = root.querySelector('#ctaStatus');

    const defaultApplyHtml = applyEditBtn ? applyEditBtn.innerHTML : '';
    const defaultReEditHtml = reEditBtn ? reEditBtn.innerHTML : '';
    const defaultContinueHtml = continueBtn ? continueBtn.innerHTML : '';
    const defaultAfterLabel = labelAfter ? labelAfter.textContent.trim() : 'Stylized';
    const editedAfterLabel = 'Edited';

    let dragging = false;
    let comparisonReady = false;

    // ── PINCH-ZOOM (mobile) ──────────────────────────────────────
    const ZOOM_MIN = 1;
    const ZOOM_MAX = 3;
    let zoomScale = 1;
    let zoomTranslateX = 0;
    let zoomTranslateY = 0;
    let isZoomedIn = false;
    let zoomViewMode = null;
    let isPinching = false;
    let isPanning = false;
    let pinchStartDist = 0;
    let pinchStartScale = 1;
    let panStartX = 0;
    let panStartY = 0;
    let panStartTranslateX = 0;
    let panStartTranslateY = 0;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function getTouchDistance(t1, t2) {
      const dx = t2.clientX - t1.clientX;
      const dy = t2.clientY - t1.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function updateHandleVisibility() {
      if (!splitHandle) return;
      splitHandle.hidden = !comparisonReady || isZoomedIn;
    }

    function enterZoomView() {
      // Once an edited "after" result exists, zoom should isolate and magnify
      // only the after image — the before image is hidden and the slider's
      // clip-path is lifted so the full after image is visible while zoomed.
      zoomViewMode = comparisonReady ? 'after' : 'before';
      if (zoomViewMode === 'after') {
        if (imgOriginal) setVisible(imgOriginal, false);
        if (styledWrap) styledWrap.style.clipPath = 'inset(0 0 0 0%)';
        if (labelBefore) labelBefore.hidden = true;
      } else if (labelAfter) {
        labelAfter.hidden = true;
      }
    }

    function exitZoomView() {
      if (zoomViewMode === 'after') {
        if (imgOriginal) setVisible(imgOriginal, true);
        if (styledWrap) setSlider(getCurrentSliderPercent());
      }
      if (labelBefore) labelBefore.hidden = false;
      if (labelAfter) labelAfter.hidden = !comparisonReady;
      zoomViewMode = null;
    }

    function setZoomedState(zoomed) {
      const next = !!zoomed;
      if (next !== isZoomedIn) {
        isZoomedIn = next;
        if (isZoomedIn) {
          enterZoomView();
        } else {
          exitZoomView();
        }
      }
      if (splitWrap) splitWrap.classList.toggle('is-zoomed', isZoomedIn);
      updateHandleVisibility();
      if (zoomResetBtn) zoomResetBtn.hidden = !isZoomedIn;
    }

    function applyZoomTransform() {
      if (!zoomStage) return;
      zoomStage.style.transform = `translate(${zoomTranslateX}px, ${zoomTranslateY}px) scale(${zoomScale})`;
    }

    function clampPan() {
      if (!splitWrap) return;
      const rect = splitWrap.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const maxOffsetX = (rect.width * (zoomScale - 1)) / 2;
      const maxOffsetY = (rect.height * (zoomScale - 1)) / 2;
      zoomTranslateX = clamp(zoomTranslateX, -maxOffsetX, maxOffsetX);
      zoomTranslateY = clamp(zoomTranslateY, -maxOffsetY, maxOffsetY);
    }

    function resetZoom(animate) {
      zoomScale = 1;
      zoomTranslateX = 0;
      zoomTranslateY = 0;
      isPinching = false;
      isPanning = false;

      if (zoomStage) {
        if (animate) {
          zoomStage.classList.add('is-zoom-animating');
          window.setTimeout(() => {
            if (zoomStage) zoomStage.classList.remove('is-zoom-animating');
          }, 250);
        }
        zoomStage.style.transform = '';
      }

      setZoomedState(false);
    }
    // ─────────────────────────────────────────────────────────────

    let isSubmitting = false;
    let hasEditedResult = false;
    let selectedDimension = 'square';
    let selectedOrientation = 'portrait';
    let originalPreviewUrl = '';
    let editablePreviewUrl = '';
    let editedPreviewUrl = '';

    const dimensionRatioMap = {
      square: { portrait: '1:1', landscape: '1:1' },
      poster: { portrait: '2:3', landscape: '3:2' },
      classic: { portrait: '3:4', landscape: '4:3' },
      standard: { portrait: '4:5', landscape: '5:4' },
      'print-friendly': { portrait: '5:7', landscape: '7:5' },
      panorama: { portrait: '1:2', landscape: '2:1' }
    };

    const loadingOverlay = document.createElement('div');
    loadingOverlay.className = 'p2p-stylize__preview-overlay';
    loadingOverlay.hidden = true;
    loadingOverlay.innerHTML = [
      '<div class="aipr-tab-loader-spinner"></div>',
      '<span class="p2p-stylize__preview-overlay-text">Loading preview...</span>'
    ].join('');
    if (splitWrap) splitWrap.appendChild(loadingOverlay);
    const loadingOverlayText = loadingOverlay.querySelector('.p2p-stylize__preview-overlay-text');

    // ── CREDIT MODAL ──────────────────────────────────────────────
    const creditModal = document.createElement('div');
    creditModal.className = 'p2p-credit-modal-backdrop';
    creditModal.hidden = true;
    creditModal.innerHTML = [
      '<div class="p2p-credit-modal" role="dialog" aria-modal="true" aria-labelledby="creditModalTitle">',
        '<button type="button" class="p2p-credit-modal__close" id="creditModalClose" aria-label="Close">&times;</button>',
        '<div class="p2p-credit-modal__icon">',
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
            '<circle cx="12" cy="12" r="10"/>',
            '<line x1="12" y1="8" x2="12" y2="12"/>',
            '<line x1="12" y1="16" x2="12.01" y2="16"/>',
          '</svg>',
        '</div>',
        '<div class="p2p-credit-modal__title" id="creditModalTitle">No More Credits</div>',
        '<div class="p2p-credit-modal__body">You\'ve used all your available AI edit credits. Upgrade your plan to keep editing your images.</div>',
        '<div class="p2p-credit-modal__error-detail" id="creditModalDetail"></div>',
        '<div class="p2p-credit-modal__actions">',
          '<button type="button" class="p2p-credit-modal__btn p2p-credit-modal__btn--primary" id="creditModalUpgrade">',
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>',
            'Upgrade Plan',
          '</button>',
          '<button type="button" class="p2p-credit-modal__btn p2p-credit-modal__btn--secondary" id="creditModalDismiss">Maybe Later</button>',
        '</div>',
      '</div>'
    ].join('');
    document.body.appendChild(creditModal);

    const creditModalDetail = creditModal.querySelector('#creditModalDetail');
    const creditModalClose = creditModal.querySelector('#creditModalClose');
    const creditModalDismiss = creditModal.querySelector('#creditModalDismiss');
    const creditModalUpgrade = creditModal.querySelector('#creditModalUpgrade');

    function showCreditModal(message) {
      if (creditModalDetail) {
        creditModalDetail.textContent = message || 'No more credits available.';
        creditModalDetail.hidden = !message;
      }
      creditModal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function hideCreditModal() {
      creditModal.hidden = true;
      document.body.style.overflow = '';
    }

    if (typeof window.showNoCreditPopup !== 'function') {
      window.showNoCreditPopup = function() {
        showCreditModal('No more credits available.');
      };
    }

    function triggerNoCreditsPopup(message) {
      let popupShown = false;

      try {
        if (typeof showNoCreditPopup === 'function') {
          showNoCreditPopup();
          popupShown = true;
        }
      } catch (_) {}

      if (!popupShown) {
        try {
          if (window && typeof window.showNoCreditPopup === 'function') {
            window.showNoCreditPopup();
            popupShown = true;
          }
        } catch (_) {}
      }

      if (!popupShown) {
        showCreditModal(message);
      }

      return popupShown;
    }

    function hasNoMoreCredits(payload) {
      if (!payload) return false;

      if (typeof payload === 'object' && payload.error && typeof payload.error === 'string') {
        try {
          if (payload.error.toLowerCase().includes('no more credits')) {
            return true;
          }
        } catch (_) {}
      }

      let message = '';
      if (typeof payload === 'string') {
        message = payload;
      } else if (typeof payload === 'object') {
        message =
          (typeof payload.error === 'string' && payload.error) ||
          (typeof payload.message === 'string' && payload.message) ||
          (typeof payload.detail === 'string' && payload.detail) ||
          '';
      }

      return !!(message && message.toLowerCase().includes('no more credits'));
    }

    function createNoCreditsError(message) {
      const error = new Error(message || 'No more credits available.');
      error.code = 'NO_MORE_CREDITS';
      return error;
    }

    function isCreditError(message) {
      return /no more credits|credits?|quota|upgrade|limit reached|insufficient/i.test(message || '');
    }

    creditModalClose && creditModalClose.addEventListener('click', hideCreditModal);
    creditModalDismiss && creditModalDismiss.addEventListener('click', hideCreditModal);
    creditModal.addEventListener('click', function(e) {
      if (e.target === creditModal) hideCreditModal();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !creditModal.hidden) hideCreditModal();
    });
    creditModalUpgrade && creditModalUpgrade.addEventListener('click', function() {
      hideCreditModal();
      const upgradeUrl = (window.Prompt2Prints && window.Prompt2Prints.upgradeUrl) || root.dataset.upgradeUrl || '/account';
      window.location.href = buildNextUrl(upgradeUrl);
    });
    // ─────────────────────────────────────────────────────────────

    function getCookie(name) {
      if (!name || !document.cookie) return null;
      for (const part of document.cookie.split('; ')) {
        const idx = part.indexOf('=');
        if (idx === -1) continue;
        if (part.slice(0, idx) !== name) continue;
        try {
          return decodeURIComponent(part.slice(idx + 1));
        } catch (_) {
          return part.slice(idx + 1);
        }
      }
      return null;
    }

    function setCookie(name, value, maxAgeSeconds) {
      if (!name) return;
      document.cookie = [
        encodeURIComponent(name) + '=' + encodeURIComponent(value || ''),
        'path=/',
        'max-age=' + String(maxAgeSeconds || 86400),
        'SameSite=Lax'
      ].join('; ');
    }

    function getStored(keys) {
      for (const key of keys) {
        if (!key) continue;

        if (typeof window.getLocalStorage1Day === 'function') {
          try {
            const expiringValue = window.getLocalStorage1Day(key);
            if (expiringValue) return expiringValue;
          } catch (_) {}
        }

        try {
          const localValue = localStorage.getItem(key);
          if (localValue) return localValue;
        } catch (_) {}

        const cookieValue = getCookie(key);
        if (cookieValue) return cookieValue;
      }
      return null;
    }

    function persistValue(keys, value) {
      keys.filter(Boolean).forEach(key => {
        if (typeof window.setLocalStorage1Day === 'function') {
          try {
            window.setLocalStorage1Day(key, value);
          } catch (_) {}
        }

        try {
          localStorage.setItem(key, value);
        } catch (_) {}

        try {
          setCookie(key, value, 24 * 60 * 60);
        } catch (_) {}
      });
    }

    function persistEditedImage(url) {
      persistValue([
        editedKey,
        'pdpEditedImage',
        stylizedKey,
        'pdpStylizedImage',
        'p2pStylizedImage',
        printImageKey,
        'pdp-select-img'
      ], url);
    }

    function persistContinueImage(url) {
      if (!url) return;

      persistValue([
        printImageKey,
        'pdp-select-img',
        editedKey,
        'pdpEditedImage',
        stylizedKey,
        'pdpStylizedImage',
        'p2pStylizedImage',
        uploadedKey,
        'pdpUploadedImage',
        'p2pUploadedImage',
        'select-print-image'
      ], url);
    }

    function getApiConfig() {
      const prompt2Prints = window.Prompt2Prints || {};
      return {
        base: prompt2Prints.apiBase || 'https://api.prompt2prints.com',
        apiKey: prompt2Prints.apiKey || ''
      };
    }

    function getCustomerId() {
      return root.dataset.customerId || window.shopifyCustomerId || 'guest';
    }

    function getSessionId() {
      if (typeof window.getLocalStorage1Day === 'function') {
        try {
          return window.getLocalStorage1Day('sessionId') || 'none';
        } catch (_) {}
      }

      try {
        return localStorage.getItem('sessionId') || 'none';
      } catch (_) {
        return 'none';
      }
    }

    function getSelectedRatio() {
      const ratioConfig = dimensionRatioMap[selectedDimension];
      if (!ratioConfig) return '';
      return ratioConfig[selectedOrientation] || ratioConfig.portrait || '';
    }

    function updateDimensionRatioLabels() {
      if (!dimensionGrid) return;

      dimensionGrid.querySelectorAll('.p2p-step3-dimension-card').forEach(card => {
        const dimension = card.dataset.dimension || '';
        const ratioEl = card.querySelector('.p2p-step3-dimension-ratio');
        const ratioConfig = dimensionRatioMap[dimension];
        if (!ratioEl || !ratioConfig) return;

        const ratioValue = ratioConfig[selectedOrientation] || ratioConfig.portrait || '';
        ratioEl.textContent = ratioValue ? `(${ratioValue})` : '';
      });
    }

    function getOriginalEditSourceUrl() {
      return (
        originalPreviewUrl ||
        getStored([
          originalKey,
          'pdpOriginalImage',
          'p2pOriginalImage',
          uploadedKey,
          'pdpUploadedImage',
          'p2pUploadedImage',
          'p2p_uploaded_image'
        ]) ||
        imgOriginal?.currentSrc ||
        imgOriginal?.src ||
        ''
      );
    }

    function getSpinnerIconMarkup() {
      return [
        '<svg class="p2p-stylize__cta-spinner" width="18" height="18" viewBox="0 0 24 24"',
        'fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">',
        '<path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83',
        'M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path>',
        '</svg>'
      ].join(' ');
    }

    function setButtonLoading(button, label) {
      if (!button) return;
      button.disabled = true;
      button.classList.add('is-loading');
      button.innerHTML = `${getSpinnerIconMarkup()} ${label}`;
    }

    function restoreButton(button, html) {
      if (!button) return;
      button.classList.remove('is-loading', 'is-error');
      button.innerHTML = html;
    }

    function setStatus(message, tone) {
      if (!ctaStatus) return;

      ctaStatus.className = 'p2p-stylize__cta-status';
      if (tone) ctaStatus.classList.add(`is-${tone}`);

      if (!message) {
        ctaStatus.hidden = true;
        ctaStatus.textContent = '';
        return;
      }

      ctaStatus.hidden = false;
      ctaStatus.textContent = message;
    }

    function setVisible(el, visible) {
      if (!el) return;
      el.style.opacity = visible ? '' : '0';
      el.style.visibility = visible ? '' : 'hidden';
    }

    function waitForImage(imgEl) {
      return new Promise(resolve => {
        if (!imgEl) return resolve();
        const currentSrc = imgEl.currentSrc || imgEl.src || imgEl.getAttribute('src');
        if (!currentSrc) return resolve();
        if (imgEl.complete && imgEl.naturalWidth > 0) return resolve();
        imgEl.addEventListener('load', resolve, { once: true });
        imgEl.addEventListener('error', resolve, { once: true });
      });
    }

    function preloadImage(url) {
      return new Promise((resolve, reject) => {
        if (!url) return reject(new Error('Missing preview URL.'));
        const previewImage = new Image();
        previewImage.onload = resolve;
        previewImage.onerror = () => reject(new Error('Unable to load the edited image preview.'));
        previewImage.src = url;
      });
    }

    function setSlider(percent) {
      const clamped = Math.max(0, Math.min(100, percent));
      if (splitHandle) splitHandle.style.left = clamped + '%';
      if (styledWrap) styledWrap.style.clipPath = `inset(0 0 0 ${clamped}%)`;
    }

    function getCurrentSliderPercent() {
      if (!splitHandle) return 50;
      const value = parseFloat(splitHandle.style.left || '50');
      return Number.isFinite(value) ? value : 50;
    }

    function scrollPreviewToTop() {
      const target = root.querySelector('.p2p-stylize__preview') || splitWrap || root;
      const raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
      raf(function () {
        raf(function () {
          try {
            const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            const behavior = prefersReducedMotion ? 'auto' : 'smooth';
            const offset = 103;
            const rect = target.getBoundingClientRect();
            const currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
            const top = Math.max(0, rect.top + currentY - offset);
            window.scrollTo({ top, left: 0, behavior });
          } catch (_) {
            try { window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); } catch (_) {}
            try { window.scrollTo(0, 0); } catch (_) {}
          }
        });
      });
    }

    function setComparisonReady(ready) {
      if (!splitWrap) return;
      comparisonReady = !!ready;
      splitWrap.classList.toggle('is-before-only', !ready);
      splitWrap.classList.toggle('is-comparison-ready', !!ready);
      updateHandleVisibility();
      if (labelAfter) labelAfter.hidden = !ready;
      // "Original" tag must always stay visible, before and after a slide/edit exists.
      if (previewHint) previewHint.hidden = !ready;
    }

    function sizePlaceholder() {
      if (!splitWrap) return;
      const width = splitWrap.clientWidth || root.clientWidth || window.innerWidth || 0;
      if (!width) return;
      const minHeight = Math.max(240, Math.min(520, Math.round(width / (4 / 3))));
     
      splitWrap.style.maxHeight = 50 + 'svh';
      if (imgOriginal) imgOriginal.style.maxHeight = 50 + 'svh';
      if (imgStyled) imgStyled.style.maxHeight = 50 + 'svh';
    }

    function animateSlider(from, to, durationMs) {
      const start = performance.now();
      (function tick(now) {
        const t = Math.min(1, (now - start) / durationMs);
        setSlider(from + (to - from) * (1 - Math.pow(1 - t, 3)));
        if (t < 1) requestAnimationFrame(tick);
      })(start);
    }

    function syncActionButtons() {
      const showApplyOnly = !hasEditedResult;

      if (ctaActions) {
        ctaActions.classList.toggle('has-two-actions', !showApplyOnly);
      }

      if (applyEditBtn) {
        applyEditBtn.hidden = !showApplyOnly;
        applyEditBtn.disabled = isSubmitting;
        applyEditBtn.classList.toggle('is-ready', showApplyOnly && !isSubmitting);
      }

      if (reEditBtn) {
        reEditBtn.hidden = showApplyOnly;
        reEditBtn.disabled = isSubmitting;
        reEditBtn.classList.toggle('is-ready', !showApplyOnly && !isSubmitting);
      }

      if (continueBtn) {
        continueBtn.hidden = showApplyOnly;
        continueBtn.disabled = isSubmitting || !hasEditedResult;
        continueBtn.classList.toggle('is-ready', !showApplyOnly && !isSubmitting && hasEditedResult);
      }
    }

    async function appendSourceToFormData(formData, sourceUrl) {
      if (!sourceUrl) {
        throw new Error('No source image found for editing.');
      }

      if (/^(data:|blob:)/i.test(sourceUrl)) {
        const response = await fetch(sourceUrl);
        if (!response.ok) {
          throw new Error(`Unable to read the current image: ${response.status}`);
        }

        const blob = await response.blob();
        const extension = blob.type === 'image/png' ? 'png' : 'jpg';
        formData.append('file', blob, `step3-edit.${extension}`);
        return;
      }

      formData.append('imageUrl', sourceUrl);
    }

    async function callEditApi(sourceUrl) {
      const config = getApiConfig();
      if (!config.apiKey) {
        throw new Error('Prompt2Prints API key is not configured on this page.');
      }

      // Suppress any global alert/confirm popups triggered during the API call
      const _origAlert = window.alert;
      const _origConfirm = window.confirm;
      window.alert = function(msg) { console.warn('[P2P Step3] Suppressed popup:', msg); };
      window.confirm = function() { return false; };

      try {
        const formData = new FormData();
        await appendSourceToFormData(formData, sourceUrl);

        formData.append('prompt', descTextarea ? descTextarea.value.trim() : '');
        formData.append('sessionId', getSessionId());
        formData.append('orientation', selectedOrientation);
        formData.append('ratio', getSelectedRatio());
        formData.append('dimension', selectedDimension);
        formData.append('page_url', window.location.href);

        const customerId = getCustomerId();
        if (customerId && customerId !== 'guest') {
          formData.append('customerId', customerId);
        }

        const response = await fetch(`${config.base}/beta-inpaint-image-with-nano`, {
          method: 'POST',
          headers: { 'x-api-key': config.apiKey },
          body: formData
        });

        let responseText = '';
        try {
          responseText = await response.text();
        } catch (_) {}

        let data = {};
        let responsePayload = responseText || {};
        try {
          data = responseText ? JSON.parse(responseText) : {};
          responsePayload = data;
        } catch (_) {}

        const hasCreditFlags = !!(
          data &&
          (data.creditRequired || data.requiresUpgrade || data.quotaExceeded ||
           data.showModal || data.showUpgrade || data.limitReached)
        );
        const creditMessage =
          (data && (
            (typeof data.message === 'string' && data.message) ||
            (typeof data.error === 'string' && data.error) ||
            (typeof data.detail === 'string' && data.detail)
          )) ||
          (typeof responsePayload === 'string' ? responsePayload : '');

        if (!response.ok) {
          if (hasNoMoreCredits(responsePayload) || hasCreditFlags) {
            throw createNoCreditsError(creditMessage || `Edit API failed with status ${response.status}.`);
          }
          throw new Error(data.error || data.message || responseText || `Edit API failed with status ${response.status}.`);
        }

        if (data.error) {
          if (hasNoMoreCredits(data) || hasCreditFlags) {
            throw createNoCreditsError(data.error || data.message);
          }
          throw new Error(data.error);
        }

        if (hasNoMoreCredits(responsePayload) || hasCreditFlags) {
          throw createNoCreditsError(creditMessage || 'No more credits. Please upgrade your plan.');
        }

      fetchCredits();
        return data;
      } finally {
        window.alert = _origAlert;
        window.confirm = _origConfirm;
      }
    }

    async function applyEditedPreview(resultUrl, animateFromStart) {
      if (!imgStyled) return;

      resetZoom(false);
      await preloadImage(resultUrl);
      imgStyled.src = resultUrl;
      setVisible(imgStyled, true);
      imgStyled.classList.remove('is-loading');
      imgStyled.classList.add('is-ready');
      editedPreviewUrl = resultUrl;
      hasEditedResult = true;

      if (labelAfter) {
        labelAfter.textContent = editedAfterLabel;
      }

      setComparisonReady(true);
      if (animateFromStart) {
        setSlider(100);
        animateSlider(100, 50, 700);
      } else {
        setSlider(getCurrentSliderPercent());
      }
    }

    async function submitEdit(button) {
      if (isSubmitting) return;

      const sourceUrl = getOriginalEditSourceUrl();
      if (!sourceUrl) {
        setStatus('Please upload an image before applying an edit.', 'error');
        return;
      }

      const previousSlider = getCurrentSliderPercent();
      const hadEditedResult = hasEditedResult;

      isSubmitting = true;
      scrollPreviewToTop();
      syncActionButtons();
      setStatus('Applying your edit...', 'loading');

      if (loadingOverlayText) {
        loadingOverlayText.textContent = 'Applying edit...';
      }
      loadingOverlay.hidden = false;

      if (imgStyled) {
        imgStyled.classList.remove('is-ready');
        imgStyled.classList.add('is-loading');
      }

      if (button === reEditBtn) {
        setButtonLoading(reEditBtn, 'Re-editing...');
      } else {
        setButtonLoading(applyEditBtn, 'Applying edit...');
      }

      if (continueBtn) {
        continueBtn.disabled = true;
        continueBtn.classList.remove('is-ready');
      }

      try {
        const data = await callEditApi(sourceUrl);
        const resultUrl = data && data.result ? data.result : '';

        if (!resultUrl) {
          throw new Error('The edit API did not return an image.');
        }

        await applyEditedPreview(resultUrl, !hadEditedResult);
        persistEditedImage(resultUrl);

        setStatus('Edit applied. You can re-edit or continue.', 'success');
      } catch (error) {
        console.error('[P2P Step 3 Edit] Unable to apply edit:', error);

        if (imgStyled) {
          imgStyled.classList.remove('is-loading');
          if (imgStyled.src) {
            imgStyled.classList.add('is-ready');
          }
        }

        if (hadEditedResult) {
          hasEditedResult = true;
          setComparisonReady(true);
          setSlider(previousSlider);
        }

        const errMsg = (error && error.message) || 'Something went wrong while applying your edit.';
        if ((error && error.code === 'NO_MORE_CREDITS') || hasNoMoreCredits(errMsg) || isCreditError(errMsg)) {
          triggerNoCreditsPopup(errMsg);
          setStatus('', null);
        } else {
          setStatus(errMsg, 'error');
        }
      } finally {
        isSubmitting = false;
        loadingOverlay.hidden = true;
        if (loadingOverlayText) {
          loadingOverlayText.textContent = 'Loading preview...';
        }

        restoreButton(applyEditBtn, defaultApplyHtml);
        restoreButton(reEditBtn, defaultReEditHtml);
        restoreButton(continueBtn, defaultContinueHtml);
        syncActionButtons();
      }
    }

    (function loadPreview() {
      resetZoom(false);
      const initialOriginalSrc = imgOriginal ? (imgOriginal.getAttribute('src') || '') : '';

      // Hide both images while loading
      if (imgOriginal) {
        setVisible(imgOriginal, false);
        try { imgOriginal.removeAttribute('src'); } catch (_) {}
      }

      if (imgStyled) {
        setVisible(imgStyled, false);
        imgStyled.classList.remove('is-loading', 'is-ready');
        try { imgStyled.removeAttribute('src'); } catch (_) {}
      }

      sizePlaceholder();

      // Page load always starts in before-only mode — show uploaded image only
      setComparisonReady(false);
      hasEditedResult = false;
      editedPreviewUrl = '';

      if (labelAfter) {
        labelAfter.textContent = defaultAfterLabel;
      }

      originalPreviewUrl = getStored([
        originalKey,
        'pdpOriginalImage',
        'p2pOriginalImage',
        uploadedKey,
        'pdpUploadedImage',
        'p2pUploadedImage',
        'p2p_uploaded_image'
      ]) || initialOriginalSrc;

      // Edit API always receives the original uploaded image as its source
      editablePreviewUrl = originalPreviewUrl;

      if (originalPreviewUrl && imgOriginal) {
        loadingOverlay.hidden = false;
        imgOriginal.src = originalPreviewUrl;
        waitForImage(imgOriginal).then(() => {
          setVisible(imgOriginal, true);
          loadingOverlay.hidden = true;
        });
      } else {
        loadingOverlay.hidden = true;
      }

      syncActionButtons();
    })();

    sizePlaceholder();
    window.addEventListener('resize', sizePlaceholder);

    function canDrag() {
      return splitWrap && splitWrap.classList.contains('is-comparison-ready') && !isZoomedIn;
    }

    function updateSlider(event) {
      if (!canDrag()) return;
      const rect = splitWrap.getBoundingClientRect();
      const percent = ((event.clientX - rect.left) / rect.width) * 100;
      setSlider(percent);
    }

    splitWrap && splitWrap.addEventListener('mousedown', event => {
      if (!canDrag()) return;
      dragging = true;
      updateSlider(event);
    });

    document.addEventListener('mousemove', event => {
      if (dragging) updateSlider(event);
    });

    document.addEventListener('mouseup', () => {
      dragging = false;
    });

    function startPan(touch) {
      isPanning = true;
      panStartX = touch.clientX;
      panStartY = touch.clientY;
      panStartTranslateX = zoomTranslateX;
      panStartTranslateY = zoomTranslateY;
    }

    zoomResetBtn && zoomResetBtn.addEventListener('click', () => {
      resetZoom(true);
    });

    splitWrap && splitWrap.addEventListener('touchstart', event => {
      if (zoomResetBtn && (event.target === zoomResetBtn || zoomResetBtn.contains(event.target))) {
        return;
      }

      if (event.touches.length >= 2) {
        isPinching = true;
        isPanning = false;
        dragging = false;
        pinchStartDist = getTouchDistance(event.touches[0], event.touches[1]);
        pinchStartScale = zoomScale;
        // Switch to zoom view the instant a pinch begins so the label swap and
        // handle hide happen immediately, instead of flickering in/out while
        // the live scale hovers near the zoomed-in threshold mid-gesture.
        setZoomedState(true);
        event.preventDefault();
        return;
      }

      if (isZoomedIn) {
        startPan(event.touches[0]);
        event.preventDefault();
        return;
      }

      if (!canDrag()) return;
      dragging = true;
      updateSlider(event.touches[0]);
    }, { passive: false });

    document.addEventListener('touchmove', event => {
      if (isPinching && event.touches.length >= 2) {
        const dist = getTouchDistance(event.touches[0], event.touches[1]);
        if (pinchStartDist > 0) {
          zoomScale = clamp(pinchStartScale * (dist / pinchStartDist), ZOOM_MIN, ZOOM_MAX);
          clampPan();
          applyZoomTransform();
        }
        event.preventDefault();
        return;
      }

      if (isPanning && event.touches.length === 1 && isZoomedIn) {
        const touch = event.touches[0];
        zoomTranslateX = panStartTranslateX + (touch.clientX - panStartX);
        zoomTranslateY = panStartTranslateY + (touch.clientY - panStartY);
        clampPan();
        applyZoomTransform();
        event.preventDefault();
        return;
      }

      if (dragging) updateSlider(event.touches[0]);
    }, { passive: false });

    function endTouchInteractions(event) {
      const remaining = event && event.touches ? event.touches.length : 0;

      if (isPinching && remaining < 2) {
        isPinching = false;
        if (zoomScale <= 1.02) {
          resetZoom(true);
        } else if (remaining === 1) {
          startPan(event.touches[0]);
        }
      }

      if (isPanning && remaining === 0) {
        isPanning = false;
        if (zoomScale <= 1.02) resetZoom(true);
      }

      dragging = false;
    }

    document.addEventListener('touchend', endTouchInteractions);
    document.addEventListener('touchcancel', endTouchInteractions);

    (function restoreSelections() {
      try {
        const savedDimension = localStorage.getItem('p2p_selected_dimension');
        if (savedDimension && dimensionGrid) {
          const selectedButton = dimensionGrid.querySelector(`[data-dimension="${savedDimension}"]`);
          if (selectedButton) {
            dimensionGrid.querySelectorAll('.p2p-step3-dimension-card').forEach(button => {
              button.classList.remove('is-selected');
              button.setAttribute('aria-pressed', 'false');
            });
            selectedButton.classList.add('is-selected');
            selectedButton.setAttribute('aria-pressed', 'true');
            selectedDimension = savedDimension;
          }
        }

        const savedOrientation = localStorage.getItem('p2p_selected_orientation');
        if (savedOrientation && (savedOrientation === 'portrait' || savedOrientation === 'landscape')) {
          selectedOrientation = savedOrientation;
          orientationTabs.forEach(tab => {
            const isActive = tab.dataset.orientation === savedOrientation;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
          if (dimensionGrid) {
            dimensionGrid.classList.toggle('is-landscape', savedOrientation === 'landscape');
          }
        }

        updateDimensionRatioLabels();

        const savedDescription = localStorage.getItem('p2p_image_description');
        if (savedDescription && descTextarea) {
          descTextarea.value = savedDescription;
        }
      } catch (_) {}
    })();

    if (dimensionGrid) {
      dimensionGrid.addEventListener('click', event => {
        const button = event.target.closest('.p2p-step3-dimension-card');
        if (!button) return;

        dimensionGrid.querySelectorAll('.p2p-step3-dimension-card').forEach(card => {
          card.classList.remove('is-selected');
          card.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        selectedDimension = button.dataset.dimension || selectedDimension;

        try {
          localStorage.setItem('p2p_selected_dimension', selectedDimension);
        } catch (_) {}
      });
    }

    orientationTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        orientationTabs.forEach(item => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-pressed', 'true');
        selectedOrientation = tab.dataset.orientation || selectedOrientation;

        if (dimensionGrid) {
          dimensionGrid.classList.toggle('is-landscape', selectedOrientation === 'landscape');
        }

        updateDimensionRatioLabels();

        try {
          localStorage.setItem('p2p_selected_orientation', selectedOrientation);
        } catch (_) {}
      });
    });

    if (descTextarea) {
      descTextarea.addEventListener('input', () => {
        try {
          localStorage.setItem('p2p_image_description', descTextarea.value);
        } catch (_) {}
      });
    }

    updateDimensionRatioLabels();

    if (applyEditBtn) {
      applyEditBtn.addEventListener('click', () => {
        submitEdit(applyEditBtn);
      });
    }

    if (reEditBtn) {
      reEditBtn.addEventListener('click', () => {
        submitEdit(reEditBtn);
      });
    }

    if (continueBtn) {
      continueBtn.addEventListener('click', () => {
        if (isSubmitting || continueBtn.disabled || !hasEditedResult) return;

        try {
          localStorage.setItem('p2p_selected_dimension', selectedDimension);
          localStorage.setItem('p2p_selected_orientation', selectedOrientation);
          if (descTextarea) localStorage.setItem('p2p_image_description', descTextarea.value);
        } catch (_) {}

        if (editedPreviewUrl) {
          persistContinueImage(editedPreviewUrl);
        }

        window.location.href = buildNextUrl(continueUrl);
      });
    }

    if (tweaksClose && tweaksPanel) {
      tweaksClose.addEventListener('click', () => {
        tweaksPanel.hidden = true;
        window.parent.postMessage({ type: '__edit_mode_dismissed' }, '*');
      });
    }

    window.addEventListener('message', event => {
      if (!tweaksPanel) return;
      if (event.data && event.data.type === '__activate_edit_mode') tweaksPanel.hidden = false;
      if (event.data && event.data.type === '__deactivate_edit_mode') tweaksPanel.hidden = true;
    });

    window.parent.postMessage({ type: '__edit_mode_available' }, '*');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
